/**
 * Pushover Notification Service (Client-side)
 * 
 * Sends push notifications to your phone via Pushover API
 * Useful for debugging on mobile devices
 */

class PushoverService {
  constructor() {
    this.userKey = process.env.REACT_APP_PUSHOVER_USER_KEY;
    this.apiToken = process.env.REACT_APP_PUSHOVER_API_TOKEN;
    this.enabled = !!(this.userKey && this.apiToken);
  }

  /**
   * Send a push notification
   * @param {string} title - Notification title
   * @param {string} message - Notification message
   * @param {string} priority - Priority: 'low', 'normal', 'high', 'emergency'
   */
  async notify(title, message, priority = 'normal') {
    if (!this.enabled) {
      console.log('📱 Pushover disabled - no credentials configured');
      return;
    }

    const priorityMap = {
      low: -1,
      normal: 0,
      high: 1,
      emergency: 2,
    };

    try {
      const formData = new URLSearchParams({
        token: this.apiToken,
        user: this.userKey,
        title: title,
        message: message,
        priority: (priorityMap[priority] || 0).toString(),
      });

      const response = await fetch('https://api.pushover.net/1/messages.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (!response.ok) {
        const error = await response.text();
        console.error('Pushover error:', error);
        return;
      }

      console.log('📱 Pushover notification sent');
    } catch (error) {
      console.error('Error sending Pushover notification:', error);
      // Don't throw - notifications are non-critical
    }
  }

  /**
   * Send a debug log notification
   * @param {string} message - Debug message
   */
  async debug(message) {
    await this.notify('🔍 Barcode Debug', message, 'normal');
  }
}

// Export singleton instance
export const pushoverService = new PushoverService();
export default pushoverService;

